import { ErrorType } from "../models/common/error";

export const initError: ErrorType = {
    errorDefault: { status: false, message: "" },
    errorOTP: { status: false, message: "" },
    errorDialogOTP: { status: false, message: "" },
    errorLoadingFile: { status: false, message: "" },
    errorParams: { status: false, message: "" }, 
    errorConnection: { status: false, message: "" }, 
    errorRegister: { status: false, message: "" }, 
}